/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";

//import './table.css';
import "./filtering.css";

import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { axiosInstance } from "../../../../services/AxiosInstance";
export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const Song = () => {
  const keys = ["id", "title"];
  const [data, setData] = useState([]);
  const [event, setEvent] = useState([]);
  const [eventkeys, setEventkeys] = useState([]);
  const [show, setShow] = useState(false);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);

  const COLUMNS = [
    ...keys.map((key) => ({
      Header: key,
      Footer: key,
      accessor: key,
      Filter: ColumnFilter,
    })),

    {
      Header: "status",
      Footer: "status",
      accessor: "status",
      Cell: ({ value }) => {
        return (
          <>
            <span class={`badge ${value === 0 ? "bg-danger" : "bg-success"}`}>
              {value === 0 ? "De-active" : "Active"}{" "}
            </span>
          </>
        );
      },
    },
    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex ">
              <Link
                to={`/JudgesSong/${row.original.id}/${row.original.title}`}
                title="View Songs"
                className={`btn btn-outline-light btn-sm rounded`}
              >
                <i className="fa fa-microphone" />
              </Link>
              <button
                onClick={() => {
                  onShow();
                  setEvent(row.original.id);
                }}
                title="View Event"
                className={`btn btn-outline-success btn-sm rounded`}
              >
                <i className="fa fa-calendar" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;
  const [loader, setLoader] = useState(false);

  const getSong = () => {
    setLoader(true);
    axiosInstance
      .get("judge/events")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);
          setEventkeys(Object.keys(response?.data.data[0]));
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };

  useEffect(() => {
    getSong();
  }, []);

  console.log(eventkeys, "eventkeys");
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">Songs</h4>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>Event Details</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {eventkeys
                .filter(
                  (s) =>
                    s !== "id" &&
                    s !== "song_upload_fees" &&
                    s !== "singer_cap_amount" &&
                    s !== "judge_cap_amount" &&
                    s !== "singer_voting_pool_percent" &&
                    s !== "singer_upload_percent" &&
                    s !== "judge_pool_percent" &&
                    s !== "status" &&
                    s !== "created_at" &&
                    s !== "updated_at" &&
                    s !== "pivot" &&
                    s !== "images"
                )
                .map((e) => {
                  return (
                    <>
                      {data
                        .filter((x) => x.id === event)
                        .map((y) => (
                          <div className="col-md-6 mb-3">
                            <h5 className="text-capitalize">
                              {e.replace(/_/g, " ")}
                            </h5>
                            <input
                              type="text"
                              value={y[e]}
                              className="form-control"
                            />
                          </div>
                        ))}
                    </>
                  );
                })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Song;
